export const tableHeaderColumns = ['Add', 'Crop', 'Name', 'Variety', 'Genetic type', 'Notes'];
